import { createContext, useContext } from 'react'

import { Invite } from '../../api/AccountInvitesService/types'
import { StateCategory } from '../../Templates/reusable/Category/state/types'
import { noop } from '../../utils/noop'

export const DEVELOPER_OPTION_KEYS = ['web_developer', 'web_development']

export type State = {
  businessName?: string
  logo?: string
  category?: StateCategory
  appDefIds?: string[]
  accountInvites?: Invite[]
  isWixStudioAccount?: boolean
  isDeveloper?: boolean
  agencyName?: string
  enterpriseFormAnswers?: Record<string, string[]>
  provisionedMetaSiteId?: string
  suggestedDomain?: string
}

export type Save = (update: Partial<State>) => void

export type Setters = {
  save: Save
}

export type StorageContextType = State & Setters

export const StorageContext = createContext<StorageContextType>({
  save: noop,
})

export const useStorageContext = () => useContext(StorageContext)
